import { Button, ButtonGroup, FlexBox } from '@dixa/lib-shared-habla';
import { useState } from 'react';

import { FormSectionTitle } from '../formSectionTitle';

import { MobileSetup } from './components/mobileSetup/mobileSetup';
import { ListPlatforms } from './components/pushNotifications/listPlatforms';
import { WebSetup } from './components/webSetup/webSetup';

type TabId = 'web' | 'mobile' | 'pushNotifications';

export interface SetupProps {
  messengerId: string;
  messengerToken: string;
}

export function Setup({
  messengerId,
  messengerToken,
}: SetupProps): JSX.Element {
  const [visibleTab, setVisibleTab] = useState<TabId>('web');

  // eslint-disable-next-line consistent-return
  function renderTab(): JSX.Element {
    switch (visibleTab) {
      case 'web':
        return <WebSetup messengerToken={messengerToken} />;
      case 'mobile':
        return <MobileSetup messengerToken={messengerToken} />;
      case 'pushNotifications':
        return <ListPlatforms messengerId={messengerId} />;
    }
  }

  return (
    <FlexBox flexDirection="column" gap="300">
      <FormSectionTitle
        title="Setup"
        description="Instructions and documentation for how to set up your Dixa Messenger on your website and implement it on your application."
      />

      <ButtonGroup variant="secondary">
        <Button
          icon="chat-widget"
          active={visibleTab === 'web'}
          onClick={() => setVisibleTab('web')}
        >
          Web
        </Button>
        <Button
          icon="phone"
          active={visibleTab === 'mobile'}
          onClick={() => setVisibleTab('mobile')}
        >
          Mobile
        </Button>
        <Button
          icon="bell"
          active={visibleTab === 'pushNotifications'}
          onClick={() => setVisibleTab('pushNotifications')}
        >
          Push notifications
        </Button>
      </ButtonGroup>
      {renderTab()}
    </FlexBox>
  );
}
